import { render, staticRenderFns } from "./CreatePreparation.vue?vue&type=template&id=1bcc36da&"
import script from "./CreatePreparation.vue?vue&type=script&lang=js&"
export * from "./CreatePreparation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports